import get from "lodash/get"
import { createSelector } from "reselect"
import orderBy from "lodash/orderBy"
import flatten from "lodash/flatten"
import {
    selectSelectedHash as selectCurrentJourneyHash,
    selectData as selectJourneyData,
} from "redux/reducers/entities/journeys"
import { selectTalentWithMissingRelations } from "redux/reducers/entities/users"
import { createReducer } from "../../../utility"
import { createUiFeatureSelector } from "../helpers"
import * as selectors from "./selectors"
import { initialState, reducers } from "./reducers"
import { reducerName } from "./actionNames"

export * from "./reducers"

// selectors
export const selectFeature = createUiFeatureSelector(reducerName)

export const selectScrollPosition = createSelector(
    selectFeature,
    selectors.selectScrollPosition,
)

export const selectShowRulesPanel = createSelector(
    selectFeature,
    selectors.selectShowRulesPanel,
)

export const selectClonedJourneyHash = createSelector(
    selectFeature,
    selectors.selectClonedJourneyHash,
)

export const selectIsRepublishing = createSelector(
    selectCurrentJourneyHash,
    selectClonedJourneyHash,
    (current, cloned) => !!cloned && current === cloned,
)

export const selectCanRepublish = createSelector(
    selectCurrentJourneyHash,
    selectClonedJourneyHash,
    (current, cloned) => !cloned || cloned === current,
)

export const selectClonedJourney = createSelector(
    selectJourneyData,
    selectClonedJourneyHash,
    get,
)

export const selectClonedJourneyName = createSelector(
    selectClonedJourney,
    journey => get(journey, "name"),
)

export const selectMissingRoles = createSelector(
    selectTalentWithMissingRelations,
    users => {
        const userRelations = flatten(users.map(user => user.userRelations))
        const uniqueUsersColumns = [
            ...new Set(userRelations.map(user => user.relationName)),
        ]
        return orderBy(uniqueUsersColumns, "asc")
    },
)

export const reducer = createReducer(reducers, initialState)
